module.exports = __webpack_public_path__ + "img/wonderWheel.f22e33b2.svg";